import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { CopyTextToClipboardModule } from '../copy-text-to-clipboard/copy-text-to-clipboard.module';
import { VisitorHistoryComponent } from './visitor-history.component';
import { ChatMessagesModule } from '../chat-messages/chat-messages.module';
import { EmailViewerModule } from '../email-viewer/email-viewer.module';
import { MessageGroupService } from 'shared/services/message-group/message-group.service';
import { LoadingModule } from 'shared/components/loading/loading.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    SvgIconModule,
    CopyTextToClipboardModule,
    ChatMessagesModule,
    EmailViewerModule,
    LoadingModule
  ],
  providers: [
    MessageGroupService
  ],
  declarations: [
    VisitorHistoryComponent
  ],
  exports: [
    VisitorHistoryComponent
  ]
})
export class VisitorHistoryModule {}
